module.exports = __webpack_public_path__ + "img/checkout-background.3ccccd4c.jpg";